import { fork, put, take } from 'redux-saga/effects';
import upload from '@/server/upload';
import { uploadFile } from '@/server/upload';

 const Toast = require('react-toast-mobile');

// 定义常量
export const types = {
    ACTIONSHEET_SHOW: 'user/ui/actionsheet/SHOW',
    ACTIONSHEET_HIDE: 'user/ui/actionsheet/HIDE',
    ACTIONSHEET_SUCCESS: 'user/ui/actionsheet/SUCCESS',
    ACTIONSHEET_UPLOAD_WITHOUT_WECHAT: 'user/ui/actionsheet/UPLOAD_WITHOUT_WECHAT',
    ACTIONSHEET_UPLOAD_FILE: 'user/ui/actionsheet/UPLOAD_FILE',
    ACTIONSHEET_UPLOAD_WECHAT: 'user/ui/actionsheet/UPLOAD_WECHAT'
}

// 定义回调函数
let callback: any;
let xhrData: any;

// 定义action接口
export interface IActionSheetAction {
    type: string;
    data?: {
        type: string, // 选择类型
        content?: any, // 携带内容
        project?: string, // 所属项目
        size?: number, // 文件大小，单位kb
        formData?: object
    };
    result?: any; // 结果
    callback?(): void; // 回调
}
// 定义状态接口
export interface IActionSheetStoreState {
    visible: boolean;
    type?: string;
    size?: number;
}

// 隐藏操作
export const hideAction = () => {
    return {
        type: types.ACTIONSHEET_HIDE
    }
}

/**
 * 非微信内文件上传
 * @param project {string} 所属项目
 */
export const uploadWithoutWechatAction = (project?: string, size?: number) => {
    const f = (event as any).target.files[0]
    if (size && f && f.size/1000 > size) {
        Toast.T.notify('文件大小不能超过' + size/1024 + 'M');
        (event as any).target.value = '';
        return {
            type: types.ACTIONSHEET_HIDE
        };
    }
    if ((event as any).target.files.length > 0) {
        return {
            type: types.ACTIONSHEET_UPLOAD_WITHOUT_WECHAT,
            data: {
                content: event,
                project
            }
        }
    }
    return {
        type: ''
    };
}

/* 文件上传
 * @param project {string} 所属项目
 */
export const uploadFileAction = (project?: string, size?: number) => {
    const f = (event as any).target.files[0]
    if (size && f && f.size/1000 > size) {
        Toast.T.notify('文件大小不能超过' + size/1024 + 'M');
        (event as any).target.value = '';
        return {
            type: types.ACTIONSHEET_HIDE
        };
    }
    if ((event as any).target.files.length > 0) {
        return {
            type: types.ACTIONSHEET_UPLOAD_FILE,
            data: {
                content: event,
                project,
            }
        }
    }
    return {};
}

const initState = {
    visible: false
}

export default (state: IActionSheetStoreState = initState, action: IActionSheetAction): IActionSheetStoreState => {
    switch (action.type) {
        case types.ACTIONSHEET_SUCCESS:
            if (callback) { 
                setTimeout(() => {
                    callback(action.result);
                }, 100);
            }
            return {
                visible: false
            };
        case types.ACTIONSHEET_SHOW:
            if (action.callback) { 
                callback = action.callback;
            }
            xhrData = action.data ? (action.data.formData || {}) : {}
            // 绑定确认处理函数
            return {
                visible: true,
                type: action.data ? action.data.type : '',
                size: action.data ? action.data.size : 0
            }
        case types.ACTIONSHEET_HIDE:
            return {
                visible: false,
            }
        default:
            return state;
    }
}

// 定义saga
/**
 * 本页面使用，获取数据异步操作处理函数
 * @param action 组件提供action
 */
function* uploadAsync(action: IActionSheetAction) {
    const r = yield upload(action.data!.content, false, action.data!.project, xhrData);
    action.data!.content.target.value = '';
    yield put({
        type: types.ACTIONSHEET_SUCCESS,
        result: r
    });
}
function* uploadFileAsync(action: IActionSheetAction) { 
    const r = yield uploadFile(action.data!.content, action.data!.project, xhrData);
    action.data!.content.target.value = '';
    yield put({
        type: types.ACTIONSHEET_SUCCESS,
        result: r
    });
}
function* uploadAsyncByWechat(action: IActionSheetAction) { 
        // var oInput = document.createElement('input');
        // oInput.value = action.data!.content;
        // document.body.appendChild(oInput);
        // oInput.select(); // 选择对象
        // document.execCommand("Copy"); // 执行浏览器复制命令
        // oInput.className = 'oInput';
        // oInput.style.display='none';


    // const r = yield uploadFile(action.data!.content);
    yield put({
        type: types.ACTIONSHEET_SUCCESS,
        result: {}
    });
}

// 利用takeEvery检测未来可能会发生的行为，并且执行相应的操作
export function* watchActionSheetUploadAsync() {
        while (true) {
            const action = yield take('*');
            switch (action.type) { 
                case types.ACTIONSHEET_UPLOAD_WITHOUT_WECHAT:
                    yield fork(uploadAsync, action);
                    break;
                case types.ACTIONSHEET_UPLOAD_FILE:
                    yield fork(uploadFileAsync, action);
                    break;
                case types.ACTIONSHEET_UPLOAD_WECHAT:
                    yield fork(uploadAsyncByWechat, action);
                default:
                    break;
            }
        }
}